<template>
<div>
</div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  created() {
    sessionStorage.setItem('displayTour', true);
    this.$router.push({
      name: 'Layout',
    });
  },
};
</script>
<style scoped>
</style>
